/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Checkbox } from '@mantine/core'

function CustomerTypesFilter (props: FilterableProps<{
  isTenant?: string | undefined,
  isLessor?: string | undefined,
  isOwner?: string | undefined,
  isProspect?: string | undefined,
  isServiceProvider?: string | undefined
}>) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Checkbox
        checked={value.isTenant === 'true'}
        label={intl.formatMessage({
          id: 'tenant',
          defaultMessage: 'Locataire'
        })}
        id="customer_type_tenant_filter"
        name="isTenant"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Checkbox
        checked={value.isLessor === 'true'}
        id="customer_type_lessor_filter"
        label={intl.formatMessage({ id: 'lessor', defaultMessage: 'Bailleur' })}
        name="isLessor"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Checkbox
        checked={value.isOwner === 'true'}
        id="customer_type_owner_filter"
        label={intl.formatMessage({
          id: 'owner',
          defaultMessage: 'Propriétaire'
        })}
        name="isOwner"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Checkbox
        checked={value.isProspect === 'true'}
        id="customer_type_prospect_filter"
        label={intl.formatMessage({
          id: 'prospect',
          defaultMessage: 'Prospect'
        })}
        name="isProspect"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Checkbox
        checked={value.isServiceProvider === 'true'}
        id="customer_type_isServiceProvider_filter"
        label={intl.formatMessage({
          id: 'service_provider',
          defaultMessage: 'Prestataire'
        })}
        name="isServiceProvider"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
    </Filter>
  )
}

export default CustomerTypesFilter
